import { apiClient } from "./client";

export const FileUploadIdentifier = {
  BRICKS_DAILY_LOG_IMAGE: "BRICKS_DAILY_LOG_IMAGE",
} as const;

export type FileUploadIdentifier = (typeof FileUploadIdentifier)[keyof typeof FileUploadIdentifier];

export interface FileInfo {
  file_id: string;
  file_name: string;
}

export interface PresignedUrlCreateRequest {
  file_infos: FileInfo[];
  file_upload_identifier: FileUploadIdentifier;
  instance_identifier?: number | null | undefined;
}

export interface FileUploadResult {
  file_upload_path: string;
  is_success: boolean;
}
export interface FileUploadResultRequest {
  file_upload_results: FileUploadResult[];
}

export interface PresignedUrl {
  file_id: string;
  url: string;
  file_upload_path: string;
}

export interface PresignedUrlCreateResponse {
  presigned_urls: PresignedUrl[];
}

export interface FileUploadResultResponseItem {
  request: {
    file_upload_path: string;
    is_success: boolean;
  };
  post_process_result: {
    image_upload_path: string | null;
    webp_image_upload_path: string | null;
    webp_image_upload_path_resized: string | null;
  };
}

export const fetchPresignedUrl = async (request: PresignedUrlCreateRequest): Promise<PresignedUrlCreateResponse> => {
  const res = await apiClient.post<PresignedUrlCreateResponse>("/file-upload/api/presigned-urls", request);
  return res.data;
};

export const updateFileUploadResult = async (
  request: FileUploadResultRequest,
): Promise<FileUploadResultResponseItem[]> => {
  const res = await apiClient.post<FileUploadResultResponseItem[]>("/file-upload/api/result", request);
  return res.data;
};
